import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const logoConsorciFn = /* @__PURE__ */ createRecipe('logo-consorci', {}, [])

const logoConsorciVariantMap = {}

const logoConsorciVariantKeys = Object.keys(logoConsorciVariantMap)

export const logoConsorci = /* @__PURE__ */ Object.assign(memo(logoConsorciFn.recipeFn), {
  __recipe__: true,
  __name__: 'logoConsorci',
  __getCompoundVariantCss__: logoConsorciFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: logoConsorciVariantKeys,
  variantMap: logoConsorciVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, logoConsorciVariantKeys)
  },
  getVariantProps: logoConsorciFn.getVariantProps,
})